import React from 'react';
import {Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@mui/material';

import {maxAgeLabel} from '../../lib/notifications';

// Every kind in the registry; click one to edit.
const TemplatesTab = ({kinds, onOpen}) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Kind</TableCell>
        <TableCell>Category</TableCell>
        <TableCell>Published</TableCell>
        <TableCell>Latest</TableCell>
        <TableCell>Max age</TableCell>
        <TableCell>What it is</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {kinds.map((k) => (
        <TableRow key={k.kind} hover sx={{cursor: 'pointer'}} onClick={() => onOpen(k)}>
          <TableCell><Typography variant="body2" sx={{fontFamily: 'monospace'}}>{k.kind}</Typography></TableCell>
          <TableCell>
            <Chip size="small" label={k.category} color={k.category === 'marketing' ? 'secondary' : 'primary'} />
          </TableCell>
          <TableCell>{k.publishedVersion ? `v${k.publishedVersion}` : <Chip size="small" color="error" label="none" />}</TableCell>
          <TableCell>{k.latestVersion ? `v${k.latestVersion}` : '—'}</TableCell>
          <TableCell>{maxAgeLabel(k.maxAgeSeconds)}</TableCell>
          <TableCell><Typography variant="body2" color="text.secondary">{k.description}</Typography></TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default TemplatesTab;
